import { useContext, useMemo } from 'react';
import useMetricUsageReport from '../../../../../hooks/useMetricUsageReport';
import InSituMetricEditorContext from '../../../../../contexts/InSituMetricEditorContext';

const useShouldWarn = (
  metric: Metrics.NormalMetric | Metrics.CompoundMetric | undefined,
) => {
  const { isInSituEditor } = useContext(InSituMetricEditorContext);
  const usageReport = useMetricUsageReport(metric);

  const { shouldWarn, usageCount } = useMemo(() => {
    if (usageReport && usageReport.usageCount > 1 && isInSituEditor) {
      return { shouldWarn: true, usageCount: usageReport.usageCount };
    }
    return { shouldWarn: false, usageCount: undefined };
  }, [isInSituEditor, usageReport]);

  return {
    shouldWarn,
    usageCount,
  };
};
export default useShouldWarn;
